<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
  <div class="banner">
    <div v-if="!isMobile" class="banner-content">
      <div class="feature-item" v-for="(item, index) in features" :key="index"
        :style="{ 'background-image': 'url(' + item.icon + ')' }">
        <div class="main-content">
          <h3>{{ item.title }}</h3>
          <p>{{ item.disc }}</p>
          <div class="rows-4">
            <banner-item title="智慧运营" subtitle="决策大脑" description='聚焦医院精细化运营，从" 看报表"升级为"问数据"' footer="决策闭环 · 高质量发展">
              <template #icon>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.48796 30.1055H2.3007C2.13443 30.1055 2 29.9714 2 29.8056V28.0204C2 27.9252 2.04245 27.837 2.11674 27.7805L8.00331 23.2612C8.20142 23.1095 8.4915 23.2506 8.4915 23.5011V30.1055H8.48796ZM16.6669 30.1055H10.4761C10.3098 30.1055 10.1754 29.9714 10.1754 29.8056V21.8465C10.1754 21.7512 10.2178 21.663 10.2921 21.6066L13.3132 19.2887C13.4335 19.197 13.6033 19.2076 13.7095 19.3134L16.5608 22.1146C16.6174 22.1711 16.6527 22.2487 16.6527 22.3298V30.1055H16.6669ZM24.8281 30.1055H18.6409C18.4746 30.1055 18.3402 29.9714 18.3402 29.8056V24.7923C18.3402 24.7112 18.372 24.6336 18.4286 24.5771L24.3152 18.7948C24.5062 18.6078 24.8281 18.7419 24.8281 19.01V30.1055ZM32.9929 30.1055H26.8057C26.6394 30.1055 26.505 29.9714 26.505 29.8056V16.7451C26.505 16.6639 26.5368 16.5863 26.5969 16.5298L30.0001 13.1924C30.1133 13.0795 30.2973 13.076 30.4176 13.1853L32.9009 15.4468C32.9646 15.5032 33 15.5844 33 15.669L32.9929 30.1055Z"
                    fill="#1CB3B8" />
                  <path
                    d="M32.0943 10.6241L30.6784 9.22825C30.5604 9.11014 30.3674 9.11014 30.2494 9.22825L19.0798 20.2303C18.9618 20.3484 18.7687 20.3484 18.6507 20.2303L13.9777 15.6204C13.8704 15.5131 13.6988 15.5023 13.5772 15.5954L2.48983 24.042C2.28961 24.1959 2 24.0527 2 23.7986V20.717C2 20.624 2.04291 20.5345 2.11799 20.4736L13.8489 11.3614C13.9705 11.2683 14.1421 11.279 14.2494 11.3864L18.6614 15.735C18.7794 15.8531 18.9725 15.8531 19.0905 15.735L27.9754 6.9806C28.097 6.85891 28.097 6.66206 27.9754 6.54395L26.3844 4.99422L33.6174 3.11522C33.8427 3.05795 34.05 3.26196 33.9893 3.49102L32.0943 10.6241Z"
                    fill="#386FC6" />
                </svg>
              </template>
            </banner-item>
            <banner-item title="智慧医保" subtitle="智能守门人" description='聚焦基金合规与支付改改，从事后扣费转向事前提醒' footer="守住基金底线·从容应对改革">
              <template #icon>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.3375 5.75C9.52928 6.68771 10.0231 7.53671 10.7435 8.16696C11.4638 8.79721 12.3709 9.17397 13.3257 9.23953L13.625 9.25003H22.375C23.3836 9.25023 24.3613 8.90195 25.1425 8.26415C25.9238 7.62635 26.4608 6.7382 26.6625 5.75H30.25C30.7096 5.75 31.1648 5.84053 31.5894 6.01643C32.014 6.19232 32.3999 6.45013 32.7249 6.77514C33.0499 7.10015 33.3077 7.48599 33.4836 7.91063C33.6595 8.33527 33.75 8.7904 33.75 9.25003V30.25C33.75 30.7097 33.6595 31.1648 33.4836 31.5894C33.3077 32.0141 33.0499 32.3999 32.7249 32.7249C32.3999 33.0499 32.014 33.3077 31.5894 33.4836C31.1648 33.6595 30.7096 33.75 30.25 33.75H5.74999C4.82173 33.75 3.9315 33.3813 3.27512 32.7249C2.61875 32.0685 2.25 31.1783 2.25 30.25V9.25003C2.24999 8.7904 2.34052 8.33527 2.51641 7.91063C2.6923 7.48599 2.9501 7.10015 3.27511 6.77514C3.60011 6.45013 3.98595 6.19232 4.41059 6.01643C4.83523 5.84053 5.29036 5.75 5.74999 5.75H9.3375ZM18 12.75C17.5359 12.75 17.0907 12.9344 16.7626 13.2626C16.4344 13.5908 16.25 14.0359 16.25 14.5V19.75H11C10.5373 19.7523 10.0944 19.9376 9.76802 20.2656C9.44166 20.5935 9.25844 21.0374 9.25844 21.5C9.25844 21.9627 9.44166 22.4065 9.76802 22.7345C10.0944 23.0624 10.5373 23.2478 11 23.25H16.25V28.5C16.25 28.9641 16.4344 29.4093 16.7626 29.7375C17.0907 30.0657 17.5359 30.25 18 30.25C18.4641 30.25 18.9093 30.0657 19.2374 29.7375C19.5656 29.4093 19.75 28.9641 19.75 28.5V23.25H25C25.4627 23.2478 25.9056 23.0624 26.232 22.7345C26.5583 22.4065 26.7416 21.9627 26.7416 21.5C26.7416 21.0374 26.5583 20.5935 26.232 20.2656C25.9056 19.9376 25.4627 19.7523 25 19.75H19.75V14.5C19.75 14.0359 19.5656 13.5908 19.2374 13.2626C18.9093 12.9344 18.4641 12.75 18 12.75Z"
                    fill="#386FC6" />
                  <path
                    d="M22.375 1C23.0712 1 23.7389 1.27656 24.2312 1.76884C24.7235 2.26113 25 2.92881 25 3.625C25 4.32119 24.7235 4.98887 24.2312 5.48116C23.7389 5.97344 23.0712 6.25 22.375 6.25H13.625C12.9288 6.25 12.2611 5.97344 11.7688 5.48116C11.2766 4.98887 11 4.32119 11 3.625C11 2.92881 11.2766 2.26113 11.7688 1.76884C12.2611 1.27656 12.9288 1 13.625 1H22.375Z"
                    fill="#1CB3B8" />
                </svg>
              </template>
            </banner-item>
            <banner-item title="智慧服务" subtitle="贴心管家" description='聚焦患者全流程就医体验升级，从单次就诊延伸到连续管理' footer="智能随行·全程暖心·极致体验">
              <template #icon>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.76342 11.4462C3.79786 11.373 4.69688 12.1478 4.7862 13.1823L4.78866 13.2138C5.22223 19.4006 8.47509 23.4041 14.8349 25.4921L15.0286 25.5548C15.8057 25.8028 16.337 26.5216 16.351 27.3385L16.3513 27.3717V32.0572C16.3513 33.1099 15.5021 33.9634 14.4547 33.9634C13.4177 33.9634 12.5751 33.127 12.5583 32.0887L12.5581 32.0572L12.558 28.7279L12.4908 28.7026C5.50757 26.0368 1.6053 20.9673 1.02243 13.7163L1.00477 13.4817C0.931162 12.4315 1.71855 11.5202 2.76342 11.4462ZM33.2366 11.4831C32.2021 11.4098 31.3031 12.1847 31.2138 13.2192L31.2113 13.2506C30.7778 19.4375 27.5249 23.4409 21.1651 25.529L20.9714 25.5917C20.1943 25.8397 19.663 26.5585 19.649 27.3754L19.6487 27.4085V32.094C19.6487 33.1468 20.4979 34.0003 21.5453 34.0003C22.5823 34.0003 23.4249 33.1638 23.4417 32.1256L23.4419 32.094L23.442 28.7648L23.5092 28.7395C30.4924 26.0736 34.3947 21.0042 34.9776 13.7532L34.9952 13.5185C35.0688 12.4684 34.2815 11.557 33.2366 11.4831Z"
                    fill="#386FC6" />
                  <path
                    d="M22.9016 3C26.088 3 28.5539 5.44041 28.5539 8.59312C28.5539 11.8006 26.1472 14.4825 22.3024 18.0346L22.022 18.2929L21.7366 18.5543L21.5921 18.6863L21.2995 18.9527L21.0022 19.2225L20.5475 19.634L19.7673 20.3387L19.1679 20.8704C18.6665 21.3153 17.9186 21.3221 17.4096 20.8909L17.3859 20.8704L16.7865 20.3387L15.8536 19.4959L15.5517 19.2225L15.1075 18.8191C15.0589 18.7748 15.0103 18.7306 14.9618 18.6863L14.674 18.4232C14.6264 18.3796 14.5791 18.3362 14.5319 18.2929L14.2515 18.0346C10.4067 14.4825 8 11.8006 8 8.59312C8 5.44041 10.4659 3 13.6523 3C15.4508 3 17.1458 3.81345 18.2769 5.13568C19.4079 3.81348 21.1031 3 22.9016 3Z"
                    fill="#1CB3B8" />
                </svg>
              </template>
            </banner-item>
            <banner-item title="智能运维" subtitle="数字保障" description='聚焦IT与AI资产治理，AI上线只是开始不是结束' footer="被动到主动·保业务连续性">
              <template #icon>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.74844 28.2C2.69844 29.25 2.69844 31.05 3.74844 32.1C4.34844 32.7 5.09844 33 5.84844 33C6.59844 33 7.34844 32.7 7.79844 32.25L17.0984 22.95L13.0484 19.05L3.74844 28.2ZM26.8484 11.1L30.8984 9L32.9984 4.95L31.0484 3L26.9984 5.1L24.8984 9.15L19.9484 13.95L22.0484 16.05L26.8484 11.1Z"
                    fill="#386FC6" />
                  <path
                    d="M27.75 21.75H27.3C26.55 21.75 25.95 21.9 25.35 22.05L13.95 10.5C14.1 9.9 14.25 9.3 14.25 8.55V8.1C14.1 5.25 11.55 3 8.7 3C7.8 3 6.9 3.15 6.3 3.6L10.05 7.35C10.2 7.5 10.35 7.65 10.35 7.95C10.65 8.55 10.5 9.45 9.9 9.9C9.6 10.35 9.15 10.5 8.7 10.5C8.4 10.5 8.25 10.5 7.95 10.35C7.8 10.2 7.5 10.2 7.35 9.9L3.6 6.15C3.3 6.9 3 7.8 3 8.55C3 11.55 5.25 13.95 8.25 14.1H8.7C9.45 14.1 10.05 13.95 10.65 13.8L22.2 25.35C22.05 25.95 21.9 26.55 21.9 27.3V27.75C22.05 30.75 24.45 33 27.45 33C28.35 33 29.1 32.85 29.85 32.4L26.1 28.65C25.95 28.5 25.8 28.2 25.65 28.05C25.35 27.45 25.5 26.55 26.1 26.1C26.4 25.8 27 25.5 27.45 25.5C27.6 25.5 27.9 25.5 28.05 25.65C28.35 25.8 28.5 25.8 28.65 26.1L32.4 29.85C32.7 29.1 33 28.35 33 27.45C33 24.45 30.75 21.9 27.75 21.75Z"
                    fill="#1CB3B8" />
                </svg>
              </template>
            </banner-item>
          </div>

        </div>
      </div>
    </div>
    <div v-if="isMobile" class="banner-content">
      <div class="feature-item" v-for="(item, index) in features" :key="index"
        :style="{ 'background-image': 'url(' + item.icon_m + ')' }">
        <div class="main-content">
          <h3 v-html="item.mobile_title"></h3>
          <p>{{ item.mobile_disc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerItem from "../../common/banner-item.vue";
export default {
  name: "BannerSection",
  components: {
    BannerItem,
  },
  data() {
    return {
      features: [
        {
          icon: require("../../../assets/home/banner_01.png"),
          icon_m: require("../../../assets/home/banner_01_m.png"),
          title: "MAGIC 医院AI通用平台",
          mobile_title: "MAGIC医院AI通用<br/>平台",
          disc: 'MagicAIOS 重构了AI交付范式，构建 "1家医院 + 1个Magic底座 + N个场景方案” 的业务架构，将复杂的医疗需求封装为标准化的“能力驱动”，实现从“单点工具交付”向“平台化生态生长”的战略升级。',
          mobile_disc: 'MagicAIOS 重构了AI交付范式，构建 "1家医院 + 1个Magic底座 + N个场景方案” 的业务架构，将复杂的医疗需求封装为标准化的“能力驱动”，实现从“单点工具交付”向“平台化生态生长”的战略升级。',
        },
      ],
      windowWidth: window.innerWidth,
      isMobile: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    const isMobile = window.innerWidth < 1300;
    this.isMobile = isMobile;
    console.log(isMobile);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    delHandleMouseEnter() {
      this.$refs.carousel.handleMouseEnter = () => { };
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 1300px) {
  .banner-content {
    margin-top: 50px;
    height: 220px !important;
  }

  .feature-item h3 {
    padding-top: 45px !important;
    padding-left: 16px !important;
    font-size: 20px !important;
  }

  .feature-item p {
    padding-top: 17px !important;
    width: 100% !important;
    line-height: 26px !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

.banner {
  width: 100%;
}

.banner-content {
  width: 100%;
  text-align: left;
  height: 820px;
  background-color: #fff;
}


.feature-item {
  height: 100%;
  width: 100%;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.feature-item h3 {
  padding-top: 177px;
  width: 60%;
  text-align: left;
  color: #1f2329;
  font-size: 64px;
  font-weight: 600;
}

.feature-item p {
  padding-top: 13px;
  width: 55%;
  text-align: left;
  color: #50627F;
  font-size: 14px;
  line-height: 27px;
}

.feature-item .samll-title h3 {
  font-size: 56px;
  margin: 184px 0 0 0;
  width: 833px;
}

.rows-4 {
  margin-top: 83px;
}
</style>
